import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a85f647e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-1 flex flex-wrap text-gary-text-color text- font-light mx-[40px] sm:pl-[50px] sm:pr-[100px] tracking-[.06em] sm:tracking-widest" }
const _hoisted_2 = { class: "w-full my-[30px] sm:mt-0 flex flex-col sm:flex-row" }
const _hoisted_3 = { class: "w-[99px] text-sm sm:text-base mb-3 sm:mb-0" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 問題分類")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-dot bg-dot-red" }, null, -1))
const _hoisted_6 = { class: "flex-1 flex flex-col gap-5 text-[0.8125rem] text-sm sm:text-base" }
const _hoisted_7 = { class: "w-[69px] sm:w-[99px] text-light-gary-text-color text-sm" }
const _hoisted_8 = { class: "flex flex-col sm:flex-row sm:gap-[50px] gap-3" }
const _hoisted_9 = { class: "w-full mb-[30px] flex flex-col sm:flex-row" }
const _hoisted_10 = { class: "w-[99px] text-sm sm:text-base mb-3 sm:mb-0" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 問題說明")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-dot bg-dot-red" }, null, -1))
const _hoisted_13 = { class: "flex-1 flex flex-col gap-5" }
const _hoisted_14 = { class: "flex sm:w-full h-[120px]" }
const _hoisted_15 = { class: "w-full mb-[30px] flex items-center" }
const _hoisted_16 = { class: "w-[82px] sm:w-[99px] text-sm sm:text-base" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 手機號碼")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-dot bg-dot-red" }, null, -1))
const _hoisted_19 = { class: "grow sm:w-[300px]" }
const _hoisted_20 = { class: "w-full mb-[30px] flex items-center" }
const _hoisted_21 = { class: "w-[82px] sm:w-[99px] text-sm sm:text-base" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Email")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-dot bg-dot-red" }, null, -1))
const _hoisted_24 = { class: "grow sm:w-[300px]" }
const _hoisted_25 = { class: "w-full mb-[30px] flex items-center" }
const _hoisted_26 = { class: "w-[82px] sm:w-[99px] text-sm sm:text-base" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 訂單編號")
const _hoisted_28 = { class: "sm:w-[248px]" }
const _hoisted_29 = { class: "w-full mb-[30px] flex" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[69px] sm:w-[99px] pt-[8px] text-sm sm:text-base" }, " 聯絡時間 ", -1))
const _hoisted_31 = { class: "flex-1 flex flex-col gap-5" }
const _hoisted_32 = { class: "flex flex-col w-fit gap-4 mt-3" }
const _hoisted_33 = { class: "w-full mb-[30px] flex items-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[86px] sm:w-[99px] text-sm sm:text-base" }, "輸入驗證碼", -1))
const _hoisted_35 = { class: "flex-1 flex flex-col gap-5" }
const _hoisted_36 = { class: "flex w-full" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full text-xs mb-[30px] flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" 訂單問題回覆時間：週一至週五 09:00 - 18:00"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 例假日及下班時間無法即時回覆，敬請見諒！ ")
  ])
], -1))
const _hoisted_38 = { class: "w-full sm:w-[248px] text-xs mb-[30px] flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Input = _resolveComponent("Input")!
  const _component_ValidateCodeWithCaptcha = _resolveComponent("ValidateCodeWithCaptcha")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _renderSlot(_ctx.$slots, "label-icon", {}, () => [
          _hoisted_5
        ], true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionTypeList, (typeList) => {
          return (_openBlock(), _createElementBlock("div", {
            key: typeList.Rank,
            class: "flex w-full"
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(typeList.QuestionGroupName), 1),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.QuestionTypeList, (questionType) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: questionType.Code,
                  class: "w-[140px]"
                }, [
                  _createVNode(_component_RadioButton, {
                    text: questionType.Name,
                    width: '18px',
                    inputValue: questionType,
                    modelValue: _ctx.selectQuestionType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectQuestionType) = $event))
                  }, null, 8, ["text", "inputValue", "modelValue"])
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _renderSlot(_ctx.$slots, "label-icon", {}, () => [
          _hoisted_12
        ], true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Textarea, {
            width: '100%',
            class: "h-[120px]",
            placeholder: '請盡量詳細說明您遇到的問題，以提高客服人員處理的速度。',
            modelValue: _ctx.questionContent,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.questionContent) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _renderSlot(_ctx.$slots, "label-icon", {}, () => [
          _hoisted_18
        ], true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_Input, {
          class: "under-line",
          width: '200px',
          modelValue: _ctx.contactMobile,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactMobile) = $event)),
          placeholder: "請輸入您的手機號碼"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _renderSlot(_ctx.$slots, "label-icon", {}, () => [
          _hoisted_23
        ], true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_Input, {
          class: "under-line",
          width: '200px',
          modelValue: _ctx.contactEmail,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactEmail) = $event)),
          placeholder: "請輸入您的Email"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _renderSlot(_ctx.$slots, "label-icon", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_Input, {
          class: "under-line",
          width: '200px',
          modelValue: _ctx.orderId,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderId) = $event)),
          required: true,
          placeholder: "若有訂單編號請輸入"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableContactTimeList, (contactTime) => {
            return (_openBlock(), _createBlock(_component_RadioButton, {
              key: contactTime.Code,
              text: contactTime.Name,
              width: '20px',
              inputValue: contactTime,
              modelValue: _ctx.selectContactTime,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectContactTime) = $event))
            }, null, 8, ["text", "inputValue", "modelValue"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_ValidateCodeWithCaptcha, {
            class: "under-line",
            height: "29px",
            width: '248px',
            placeholder: "請輸入驗證碼",
            onGetCaptchaImage: _ctx.getCaptchaImage,
            image: _ctx.captchaBase64Image,
            captchaCode: _ctx.captchaCode,
            "onUpdate:captchaCode": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.captchaCode) = $event))
          }, null, 8, ["onGetCaptchaImage", "image", "captchaCode"])
        ])
      ])
    ]),
    _hoisted_37,
    _createElementVNode("div", _hoisted_38, [
      _createVNode(_component_Btn, {
        onClick: _ctx.addCustomContact,
        class: "text-sm",
        text: '確定送出',
        height: '36px',
        width: '100%'
      }, null, 8, ["onClick"])
    ])
  ]))
}